const CONTACTUS_API =
  "https://jettyestates.com/apis/ContactSubmissions.php";
  const LEADS_API = "https://jettyestates.com/apis/leads.php";

const Login_api = "https://jettyestates.com/apis/login.php";
const Signup_api = "https://jettyestates.com/apis/signup.php";

const APPLY_JOB = "https://jettyestates.com/apis/Careers.php";

const Fetch_all_data =
  "https://jettyestates.com/apis/fetch_all_data.php";

const CRUD_Domains = "https://jettyestates.com/apis/CRUD_Domains.php";

const CRUD_Price_table = "https://jettyestates.com/apis/CRUD_Price_table.php";


const GoogelAnalytics_API ="https://jettyestates.com/apis/ga/dashboard.php";

export {
  CONTACTUS_API,LEADS_API,
  Login_api,GoogelAnalytics_API,
  Signup_api,
  APPLY_JOB,
  Fetch_all_data,
  CRUD_Domains,
  CRUD_Price_table,
};
